// Libraries
import React, { useState, useEffect } from "react"
import { connect } from "react-redux"
import StyledDialog from "../../../../../../components/StyledDialog/StyledDialog";
import {Container, Label} from "../../../../../../structureComponents";
import StyledButton from "../../../../../../components/StyledButton/StyledButton";
import StyledInput from "../../../../../../components/StyledInput/StyledInput";
import Video from "../../../../../../store/modules/videos/video.model";
import {createVideo, updateVideoById} from "../../../../../../store/modules/videos/actions";
import SvgIcon from "../../../../../../components/SvgIcon/SvgIcon";
import videoIcon from "../../../../../../assets/icons/videos.svg"
import {setSnackbarState} from "../../../../../../store/modules/global/actions";


function UpdateVideoDialog({
    active = false,
    onClose = () => ({}),
    currentVenture,
    dispatchUpdateVideo = () => ({}),
    videoToBeUpdated,
    dispatchSnackbar
}) {
    // States
    const [loading, setLoading] = useState(false)
    const [video, setVideo] = useState(new Video({}))
    const [userHasChanges, setUserHasChanges] = useState(false)

    // Mounted
    useEffect(() => {
        setUserHasChanges(false)
    }, [])

    // Watchers
    useEffect(() => {
        if (active) {
            setUserHasChanges(false)
        }
    }, [active])

    useEffect(() => {
        if (videoToBeUpdated) {
            setVideo(new Video({ ...videoToBeUpdated }))
        }
    }, [videoToBeUpdated])

    // Methods
    const handleClose = () => {
        onClose()
    }

    const handleUpdateVideo = async (e) => {
        try {
            e.preventDefault()
            setLoading(true)

            await dispatchUpdateVideo({
                ventureId: currentVenture.id,
                corporationId: currentVenture.corporationId,
                videoId: video.id
            }, {
                name: video.name,
                url: video.url
            })

            dispatchSnackbar({
                type: "success",
                active: true,
                message: "Video atualizado com sucesso"
            })
            setLoading(true)
            handleClose()
        } catch (error) {
            dispatchSnackbar({
                type: "error",
                active: true,
                message: "Infelizmente ocorreu um erro"
            })
        } finally {
            setLoading(false)
        }
    }

    const handleVideoNameOnChange = (e) => {
        const videoName = e.target.value
        setVideo({ ...video, name: videoName })
        setUserHasChanges(true)
    }

    const getVideoId = (url) => {
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url.match(regExp);

        return (match && match[2].length === 11)
            ? match[2]
            : null;
    }

    const handleVideoUrlOnChange = (e) => {
        const videoId = getVideoId(e.target.value)
        const url = `https://www.youtube.com/embed/${videoId}`
        setVideo({ ...video, url })
        setUserHasChanges(true)
    }


    return (
        <StyledDialog
            title="Atualizar video"
            active={active}
            onClose={handleClose} maxWidth="sm">
            <form onSubmit={handleUpdateVideo}>
                <Container>
                    <Label bold>Nome</Label>
                    <Container mt="10px">
                        <StyledInput
                            placeholder="Nome do video"
                            value={video.name}
                            onChange={handleVideoNameOnChange} />
                    </Container>
                </Container>
                <Container mt="20px">
                    <Label bold>URL</Label>
                    <Container mt="10px">
                        <StyledInput
                            placeholder="URL do video"
                            value={video.url}
                            onChange={handleVideoUrlOnChange} />
                    </Container>
                </Container>
                {video.url ? (
                    <Container mt="20px">
                        <iframe
                            type="text/html"
                            frameBorder="0"
                            id="player"
                            width="100%"
                            style={{height: "300px"}}
                            src={video.url} />
                    </Container>
                ) : (
                    <Container height="300px" flex alignCenter justifyCenter mt="20px" border="1px solid #ccc">
                        <SvgIcon src={videoIcon} size="80px" color="#888" />
                    </Container>
                )}
                <Container flex alignCenter justifyEnd mt="40px">
                    <Container>
                        <StyledButton
                            kind="primary-outlined"
                            onClick={handleClose}>
                            Cancelar
                        </StyledButton>
                    </Container>
                    <Container disabled={!userHasChanges} ml="10px">
                        <StyledButton
                            disabled={!userHasChanges}
                            kind="primary" type="submit"
                            loading={loading}>
                            Salvar
                        </StyledButton>
                    </Container>
                </Container>
            </form>
        </StyledDialog>
    )
}

const mapStateToProps = (state) => ({
    currentVenture: state.ventures.currentVenture,
})

const mapDispatchToProps = (dispatch) => ({
    async dispatchUpdateVideo({ corporationId, ventureId, videoId }, { name, url }) {
        await dispatch(updateVideoById({ corporationId, ventureId, videoId }, { name, url }))
    },

    dispatchSnackbar({ message, type, active }) {
        dispatch(setSnackbarState({ message, type, active }))
    }
})


export default connect(mapStateToProps, mapDispatchToProps)(UpdateVideoDialog)
